import { useState } from "react";
import { CircularProgress, IconButton, InputAdornment, TextField } from "@material-ui/core";

/**
 * @see https://v4.mui.com/components/text-fields/
 */
const CustomInput = ({
    variant,
    type,
    label,
    margin,
    name,
    handleBlur,
    handleChange,
    handleFocus,
    value,
    errors,
    touched,
    placeholder,
    required,
    disabled,
    InputProps,
    inputProps,
    style,
    styleContainer,
    readOnly,
    multiline,
    minRows,
    maxRows,
    inheritLabel,
    loadingCEP,
    helperText,
    error,
    refs,
    className,
    autoFocus,
    InputLabelProps,
}) => {
    const [showPassword, setShowPassword] = useState(false);

    const endAdornment = () => {
        if (loadingCEP) {
            return (
                <InputAdornment position="end">
                    <CircularProgress size={15} />
                </InputAdornment>
            );
        } else if (name?.includes("password")) {
            return (
                <InputAdornment position="end">
                    <IconButton
                        onClick={(e) => {
                            e.preventDefault();
                            setShowPassword(!showPassword);
                        }}>
                        <i className={showPassword ? "far fa-eye-slash" : "far fa-eye"} style={{ color: "#6B7280", fontSize: 15 }} />
                    </IconButton>
                </InputAdornment>
            );
        }
    };

    return (
        <div className={`d-flex flex-column gap-8 ${className ?? ""}`} style={{ marginBottom: 8, ...styleContainer }}>
            {label && !inheritLabel && (
                <span title={label} className="tt-14 medium color-dark-7 overflow-ellipsis w-100" htmlFor={name}>
                    {label}
                    {required ? <span className="color-primary-08"> *</span> : ""}
                </span>
            )}

            <TextField
                ref={refs}
                variant={variant ?? "outlined"}
                type={type || (name?.includes("password") && !showPassword ? "password" : "text")}
                required={required}
                label={inheritLabel && label ? label : null}
                margin={margin}
                className="mb-0"
                style={{ margin: 0, marginTop: 16, ...style }}
                name={name}
                onBlur={handleBlur}
                onChange={handleChange}
                onFocus={handleFocus}
                value={value}
                helperText={(helperText ?? (name && touched && errors && touched[name])) ? errors[name] : null}
                error={error || (name && touched && errors) ? Boolean(touched[name] && errors[name]) : false}
                placeholder={placeholder}
                InputProps={{
                    ...{ endAdornment: endAdornment() },
                    ...InputProps,
                }}
                inputProps={{
                    ...{
                        maxLength: name?.includes("cep") ? 9 : name?.includes("telefone") ? 15 : name?.includes("cnpj") ? 18 : name?.includes("cpf") ? 14 : undefined,
                    },
                    ...inputProps,
                }}
                InputLabelProps={InputLabelProps}
                disabled={disabled}
                readOnly={readOnly}
                multiline={multiline}
                minRows={minRows}
                maxRows={maxRows}
                autoFocus={autoFocus}
            />
        </div>
    );
};

export default CustomInput;
